export default __webpack_public_path__ + "static/media/gallery-img9.57f4f7e5.jpeg";